export const WIDGET_SCROLL_RESTORATION_ID = "widget-scroll-area";
export const WIDGET_SCROLL_RESTORATION_SELECTOR = `[data-scroll-restoration-id="${WIDGET_SCROLL_RESTORATION_ID}"]`;
